<div class="container course-detail">
    <div class="box-default3 w-100 shadow-lg">
      <h4>Ability Enhancement Courses</h4>
        <img src="assets/img/course/aec1.pnf" alt="AEC Image" class="img-fluid">
    </div>
</div>